<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        @change="onChangeReds($event)"
      />
      <span class="red"></span> Sem 1ª consulta
      <span
        v-b-tooltip.hover
        title="Pessoas sem primeira consulta odontológica programada válida no quadrimestre atual"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        @change="onChangeGreens($event)"
      />
      <span class="green"></span> Com 1ª consulta
      <span
        v-b-tooltip.hover
        title="Pessoas com primeira consulta odontológica programada atualizada ou registro de tratamento concluído"
        class="icon-tooltip"
      >
        <i class="icofont-info-circle"></i>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: false,
    },
    setGreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
    }
  },
  watch: {
    setRed(newValue) {
      if (newValue === true) {
        this.greens = false
        this.reds = true
      }
    },

    setGreen(newValue) {
      if (newValue === true) {
        this.reds = false
        this.greens = true
      }

      if (newValue === false) {
        this.greens = false
      }
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.$emit('exibirVerdes', event.target.checked)
    },
  },
}
</script>

<style></style>
